module.exports = __webpack_public_path__ + "static/media/arrow_upward_on.b13ea139.svg";